<template>
  <div class="o-checkbox">
    <template v-if="template === 'edit' || typeof template === 'undefined'">
      <input
        :class    = "'o-checkbox__input qa-' + field.name + '__input'"
        ref       = "input"
        type      = "checkbox"
        @change   = "update($event.target)"
        :value    = "value"
        :disabled = "field.readonly"
        :readonly = "field.readonly"
        :checked  = "value"
      />
      <label class="o-checkbox__label">{{ field.label + (field.required ? '* ' : '') }}</label>
    </template>
    <template v-if="template === 'detail'">
      <label :class="labelClass ? labelClass : 'u-label'">
        {{ field.label + (field.required ? '* ' : '') }}
      </label>
      <input
        :class    = "'o-checkbox__input qa-' + field.name + '__input'"
        ref       = "input"
        type      = "checkbox"
        :value    = "value"
        :disabled = "field.readonly"
        :readonly = "field.readonly"
        :checked  = "value"
        disabled
      />
      <label class="o-checkbox__label">{{ field.label }}</label>
    </template>
  </div>
</template>


<script>
import $ from 'jquery'

export default {
  props: ['field', 'value', 'labelClass', 'template'],
  methods: {
    update (target) {
      let value = $(target).prop('checked') ? 1 : 0
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// FieldBool.vue?0ece7a54